// @ts-nocheck
import React from 'react';
import { Download } from 'lucide-react';

interface StatsSectionProps {
  sectionId: string;
  sectionData?: any[];
  [key: string]: any;
}

const stats = [
  {
    stat: "40+",
    unit: "Hours",
    label: "Research Time",
    desc: "The average time a parent spends researching, coordinating, and registering for summer programs annually.",
    color: "border-blue-200 dark:border-blue-900/30 bg-blue-50/50 dark:bg-blue-950/20",
  },
  {
    stat: "$1,200",
    unit: "",
    label: "Shadow Cost",
    desc: "The estimated economic value of parental labor lost to manual planning per family.",
    color: "border-emerald-200 dark:border-emerald-900/30 bg-emerald-50/50 dark:bg-emerald-950/20",
  },
  {
    stat: "42%",
    unit: "",
    label: "Midnight Planners",
    desc: "The percentage of parents forced to handle logistics between 9 PM and 5 AM due to the complexity of the task.",
    color: "border-amber-200 dark:border-amber-900/30 bg-amber-50/50 dark:bg-amber-950/20",
  },
  {
    stat: "87%",
    unit: "",
    label: "Productivity Drain",
    desc: "Working parents who report significant workplace distractions caused by unresolved summer scheduling conflicts.",
    color: "border-violet-200 dark:border-violet-900/30 bg-violet-50/50 dark:bg-violet-950/20",
  },
  {
    stat: "$300-$550",
    unit: "",
    label: "Mistake Cost",
    desc: "With camp tuition increasing 20% annually, a single double-booked week or missed Early Bird window costs families in non-refundable deposits or lost savings.",
    color: "border-orange-200 dark:border-orange-900/30 bg-orange-50/50 dark:bg-orange-950/20",
  },
  {
    stat: "9%",
    unit: "",
    label: "Weekly Time Lost",
    desc: "The average parent spends 9% of their weekly time on summer logistics during the peak months of March through May.",
    color: "border-blue-200 dark:border-blue-900/30 bg-blue-50/50 dark:bg-blue-950/20",
  },
  {
    stat: "71%",
    unit: "",
    label: "Mental Load",
    desc: "Mothers handle approximately 71% of household scheduling and coordination, leading to higher rates of emotional exhaustion and summer burnout.",
    color: "border-emerald-200 dark:border-emerald-900/30 bg-emerald-50/50 dark:bg-emerald-950/20",
  },
  {
    stat: "2-4",
    unit: "Months",
    label: "Booking Window",
    desc: "Many sessions are fully booked within the first few months of the year, creating a high-stress window for manual planners.",
    color: "border-amber-200 dark:border-amber-900/30 bg-amber-50/50 dark:bg-amber-950/20",
  },
];

const StatsSection: React.FC<StatsSectionProps> = ({
  sectionId,
  sectionData,
  ...extraProps
}) => {
  return (
    <section id={sectionId} className="bg-primary/5 dark:bg-primary/10 border-y">
      <div className="container px-4 md:px-6 py-16 lg:py-24">
        <div className="flex w-full flex-col items-center justify-center text-center mb-12">
          <p className="pb-3 font-bold text-destructive text-sm tracking-wide uppercase">The Problem</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold max-w-3xl">
            How CampScout Returns <span className="text-primary underline underline-offset-4">40+ Hours</span> to the Modern Family
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2.5 lg:gap-3 max-w-5xl mx-auto">
          {stats.map((item) => (
            <div
              key={item.label}
              className={`flex flex-col items-center text-center gap-1.5 p-3 lg:p-4 border rounded-xl bg-background ${item.color} box-shadow-card hover-elevate relative overflow-visible`}
              data-testid={`stat-card-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="text-xl lg:text-2xl font-extrabold text-primary">
                {item.stat}
                {item.unit && <span className="text-lg lg:text-xl"> {item.unit}</span>}
              </div>
              <span className="text-[11px] font-bold text-foreground uppercase tracking-wide">{item.label}</span>
              <p className="text-[11px] text-muted-foreground font-medium leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="flex justify-center pt-8">
          <a
            href="/ActivityFox-Summer-Logistics-White-Paper.pdf"
            download
            className="servibe-btn servibe-btn-primary inline-flex items-center gap-2 px-8 py-3.5 text-base"
            data-testid="button-download-white-paper"
          >
            <span className="flex items-center gap-2">
              <Download className="h-5 w-5" />
              Read Our Research
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
